import { Asset } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const useSearchAssetsByName = () => {
  const { getTenantId } = useTenants();

  const searchAssetsByName = async (assetName: string): Promise<Asset[]> => {
    const response = await api.crossTenant.textSearch(getTenantId(), {
      searchQuery: `"${assetName}"`,
      filters: {
        extensions: [],
        folders: [],
        metadata: {},
      },
      page: 1,
      perPage: 50,
    });

    return response.data.matches?.map(match => match.asset) || [];
  };

  return {
    searchAssetsByName,
  };
};
